// extracted by mini-css-extract-plugin
module.exports = {"main":"StoresMobile_main__1x_P8","types":"StoresMobile_types__3yzSi","type":"StoresMobile_type__2p04j","active":"StoresMobile_active__2wYYQ","store":"StoresMobile_store__2q1Wb"};